import { axiosInstance } from "@/plugins/axios";
import {NetCost, RawNetCost} from "@/modules/net_cost/types";

export interface NetCostPayload {
  offset: null,
  limit: null,
  orderBy: null,
  orderDesc: null,
  search: null,
  start_application_date: null,
  end_application_date: null
}

export async function saveNetCost(net_cost: NetCost) {
    await axiosInstance.post(`net_costs`, net_cost);
}

export async function saveNetCosts(net_costs: NetCost[]) {
  await axiosInstance.post(`net_costs/create_or_update_many`, {
    net_costs: net_costs
  });
}

export async function saveRawNetCosts(net_costs: RawNetCost[]) {
  await axiosInstance.post(`net_costs/raw/create_or_update_many`, {
    net_costs: net_costs
  });
}

export async function getNetCosts(payload: NetCostPayload){
  let url = 'net_costs?';

  if (payload.limit) {
      url += `limit=${payload.limit}&offset=${payload.offset}&`;
  }

  if (payload.search) {
      url += `search=${payload.search}&`;
  }

  if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
    url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`
  }

  if (payload && payload.orderBy !== '') {
    url += `orderBy=${payload.orderBy}&orderDesc=${payload.orderDesc}`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
}

export async function deleteNetCost(id: string){
  await axiosInstance.delete(`net_costs/${id}`)
}
